import React from 'react';

export default class TimeBlock extends React.PureComponent {
  render() {
    const {secondsPerPixel} = this.props;
    const width = 3600 / secondsPerPixel;
    return (
      <div className="time-block" style={{width: width + 'px'}}>
        {this.props.children}
      </div>
    );
  }
}
